import { ADD_SELLITEM, ADD_SELLITEM_FAIL, ADD_SELLITEM_SUCCESS, ALL_SELLITEM_FROM_COLLECTION_ID, ALL_SELLITEM_FROM_COLLECTION_ID_FAIL, ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS, ALL_SELLITEM_NFT_COUNT, ALL_SELLITEM_NFT_COUNT_ID_FAIL, ALL_SELLITEM_NFT_COUNT_SUCCESS, GET_ALL_SELLITEM, GET_ALL_SELLITEM_FAIL, GET_ALL_SELLITEM_SUCCESS, GET_EXPLORE_LISTING, GET_EXPLORE_LISTING_FAIL, GET_EXPLORE_LISTING_SUCCESS, GET_PARTICULAR_SELLITEM, GET_PARTICULAR_SELLITEM_FAIL, GET_PARTICULAR_SELLITEM_SUCCESS, GET_RECENT_LISTING, GET_RECENT_LISTING_FAIL, GET_RECENT_LISTING_SUCCESS, LIKE_VIEW_SELLITEM, LIKE_VIEW_SELLITEM_FAIL, LIKE_VIEW_SELLITEM_SUCCESS, SELLITEM_FROM_COLLECTION_ID, SELLITEM_FROM_COLLECTION_ID_FAIL, SELLITEM_FROM_COLLECTION_ID_SUCCESS, SELL_ITEM_CURRENT_OWNER, SELL_ITEM_CURRENT_OWNER_FAIL, SELL_ITEM_CURRENT_OWNER_SUCCESS, TOP_SELL_ITEM, TOP_SELL_ITEM_FAIL, TOP_SELL_ITEM_SUCCESS, TRENDING_ARTWORK, TRENDING_ARTWORK_FAIL, TRENDING_ARTWORK_SUCCESS, UPDATE_PARTICULAR_SELLITEM, UPDATE_PARTICULAR_SELLITEM_FAIL, UPDATE_PARTICULAR_SELLITEM_SUCCESS, GET_CANVAS_PAPER_SIZE, GET_CANVAS_PAPER_SIZE_SUCCESS,GET_CANVAS_PAPER_SIZE_FAIL  } from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  sellItem: {},
  sellItems: [],
  sellItemFromCollectionID: [],
  allSellItemFromCollection: [],
  sellItemsCurrentOwner: [],
  topSellItemData: [],
  trendingArtWorks: [],
  recentListings: [],
  allSellItemNftCounts: 0,
  totalSellItem: 0,
  exploreListing: [],
  canvasPaperSizes:{}

};

const SellItems = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARTICULAR_SELLITEM:
      return {
        ...state,
        loading: true,
      };

    case GET_PARTICULAR_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        sellItem: action.payload.data || {},
      };

    case GET_PARTICULAR_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case GET_ALL_SELLITEM:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        sellItems: action.payload.data || [],
        totalSellItem: action.payload.count
      };

    case GET_ALL_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case UPDATE_PARTICULAR_SELLITEM:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PARTICULAR_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        //   sellItems: action.payload.data || [],
      };

    case UPDATE_PARTICULAR_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



    case ADD_SELLITEM:
      return {
        ...state,
        loading: true,
      };

    case ADD_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        //   sellItems: action.payload.data || [],
      };

    case ADD_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case SELLITEM_FROM_COLLECTION_ID:
      return {
        ...state,
        loading: true,
      };

    case SELLITEM_FROM_COLLECTION_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        sellItemFromCollectionID: action.payload.data || [],
      };

    case SELLITEM_FROM_COLLECTION_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case LIKE_VIEW_SELLITEM:
      return {
        ...state,
        loading: true,
      };

    case LIKE_VIEW_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case LIKE_VIEW_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case ALL_SELLITEM_FROM_COLLECTION_ID:
      return {
        ...state,
        loading: true,
      };

    case ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        allSellItemFromCollection: action.payload.data || [],
        sellItemFromCollectionID: action.payload.data || [],
      };

    case ALL_SELLITEM_FROM_COLLECTION_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



    case ALL_SELLITEM_NFT_COUNT:
      return {
        ...state,
        loading: true,
      };

    case ALL_SELLITEM_NFT_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        allSellItemNftCounts: action.payload || 0
      };

    case ALL_SELLITEM_NFT_COUNT_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case SELL_ITEM_CURRENT_OWNER:
      return {
        ...state,
        loading: true,
      };

    case SELL_ITEM_CURRENT_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        sellItemsCurrentOwner: action.payload || 0
      };

    case SELL_ITEM_CURRENT_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case TOP_SELL_ITEM:
      return {
        ...state,
        loading: true,
      };

    case TOP_SELL_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        topSellItemData: action.payload || 0
      };

    case TOP_SELL_ITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case TRENDING_ARTWORK:
      return {
        ...state,
        loading: true,
      };

    case TRENDING_ARTWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        trendingArtWorks: action.payload || []
      };

    case TRENDING_ARTWORK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case GET_RECENT_LISTING:
      return {
        ...state,
        loading: true,
      };

    case GET_RECENT_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        recentListings: action.payload.data || []
      };

    case GET_RECENT_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_EXPLORE_LISTING:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPLORE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        exploreListing: action.payload.data || []
      };
    case GET_EXPLORE_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



      case GET_CANVAS_PAPER_SIZE:
        return {
          ...state,
          loading: true,
        };
      case GET_CANVAS_PAPER_SIZE_SUCCESS:
        return {
          ...state,
          loading: false,
          canvasPaperSizes: action.payload.data || []
        };
      case GET_CANVAS_PAPER_SIZE_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload
        };

    default:
      return state;
  }
}

export default SellItems;